import { c as _c } from "react/compiler-runtime";
import { HOTEL_DETAILS_ACTIVE_TAB } from "@website/accommodation-ui/constant/keys";
import { HotelCardInfoOptions } from "@website/accommodation-ui/hotel-card-new/hotel-card-info/hotel-card-info-options";
import { HotelCardInfoPropertiesType } from "@website/accommodation-ui/hotel-card-new/hotel-card-info/hotel-card-info.types";
import { HotelCardRating } from "@website/accommodation-ui/hotel-card-new/hotel-card-info/hotel-card-rating";
import { HotelCardLink, HotelCardLinkProperties } from "@website/accommodation-ui/hotel-card-new/hotel-card-link";
import { HotelCardStars } from "@website/accommodation-ui/hotel-card-new/hotel-card-stars";
import { HotelSnappPayBadge } from "@website/accommodation-ui/hotel-snapp-pay";
import { useCompatRouter } from "@website/hooks/compat-router";
import { useViewPort } from "@website/hooks/viewport";
import { MaterialIcon } from "@website/icons/material";
import { LazyImage } from "@website/ui/lazy-image";
import { MiniChips } from "@website/ui/mini-chips";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import snappProBadge from "@website/widget/header/assets/pro_badge.svg";
import omit from "lodash-es/omit";
import { FC, MouseEvent } from "react";
export const HotelCardInfo: FC<HotelCardInfoPropertiesType> = properties => {
  const $ = _c(145);
  const router = useCompatRouter();
  const {
    hotelTitle,
    stars,
    rating,
    reviewCount,
    address,
    roomTitle,
    roomCount,
    regularBadges,
    advertisementBadge,
    size: t0,
    isFomo,
    snappPayData,
    loading,
    pricing,
    isSuggestedCard,
    facilities,
    id,
    showMap,
    location,
    propertyId,
    reservationInfo,
    isInstant,
    linkProperties,
    isAvailable,
    hasSnappProDiscount,
    transportation,
    isHotelDomHomePage
  } = properties;
  const size = t0 === undefined ? "responsive" : t0;
  const {
    date_from,
    date_to
  } = router.query;
  const {
    isMobile
  } = useViewPort();
  const TitleComponent = size === "small" ? "span" : "h3";
  const appName = process.env.NEXT_PUBLIC_APP_NAME;
  const isVillaAllowed = appName === "villa" && size !== "small";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["hotel-domestic", "hotel-international", "tour"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isHotel = t1.includes(appName ?? "");
  const isInternational = appName === "hotel-international" || properties.isInternational;
  const isHomePage = appName === "homepage" || appName === "website";
  const hasDate = Boolean(date_from && date_to);
  const hasPassenger = Boolean(reservationInfo?.bedCount) && Number(reservationInfo?.bedCount) > 0;
  let t2;
  if ($[1] !== id || $[2] !== router) {
    t2 = event => {
      event.stopPropagation();
      event.preventDefault();
      router.replace(router?.pathname, {
        ...router?.query,
        [HOTEL_DETAILS_ACTIVE_TAB]: "features",
        selectedHotelId: id
      }, {
        shallow: true,
        scroll: false
      });
    };
    $[1] = id;
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const onHotelDetailClick = t2;
  const t3 = `flex min-w-0 shrink grow flex-col ${size === "xSmall" ? "" : size === "small" ? "gap-2" : "gap-3 pt-3 md:px-3 lg:pt-0"} `;
  const t4 = `flex flex-col ${size === "xSmall" ? "gap-0" : "gap-0.5"}`;
  let t5;
  if ($[4] !== advertisementBadge?.text) {
    t5 = advertisementBadge?.text && <MiniChips color="ads" size="small" text={advertisementBadge?.text} variant="contained" />;
    $[4] = advertisementBadge?.text;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = linkProperties as HotelCardLinkProperties;
  const t7 = `hotel-card-title text-on-surface-high-emphasis flex flex-row gap-1 truncate font-bold ${size === "xSmall" ? "text-xs" : size === "small" ? "text-subtitle-1" : ""}`;
  let t8;
  if ($[6] !== hasSnappProDiscount || $[7] !== size) {
    t8 = hasSnappProDiscount ? <LazyImage className="shrink-0" src={snappProBadge.src} alt="Snapp Pro" loading="eager" fetchPriority="high" width={size === "xSmall" ? 16 : 24} height={size === "xSmall" ? 16 : 24} /> : null;
    $[6] = hasSnappProDiscount;
    $[7] = size;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = isInternational ? "en" : router.locale || "fa";
  let t10;
  if ($[9] !== hotelTitle || $[10] !== t9) {
    t10 = numberConvert(hotelTitle, {
      locale: t9
    });
    $[9] = hotelTitle;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10) {
    t11 = <span className="block min-w-0 truncate">{t10}</span>;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== TitleComponent || $[15] !== t11 || $[16] !== t7 || $[17] !== t8) {
    t12 = <TitleComponent className={t7} data-testid="hotel_card_title" dir={appName === "hotel-international" ? "ltr" : "rtl"}>{t8}{t11}</TitleComponent>;
    $[14] = TitleComponent;
    $[15] = t11;
    $[16] = t7;
    $[17] = t8;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t6) {
    t13 = <HotelCardLink {...t6} className="min-w-0 flex-1 truncate">{t12}</HotelCardLink>;
    $[19] = t12;
    $[20] = t6;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13 || $[23] !== t5) {
    t14 = <div className="flex flex-row items-center gap-1">{t5}{t13}</div>;
    $[22] = t13;
    $[23] = t5;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  const t15 = `${isSuggestedCard ? "mt-1 flex flex-col items-start justify-between" : "hidden"}`;
  let t16;
  if ($[25] !== size || $[26] !== stars) {
    t16 = <HotelCardStars size={size} starSize="small" stars={stars} />;
    $[25] = size;
    $[26] = stars;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== id || $[29] !== propertyId || $[30] !== rating || $[31] !== reviewCount || $[32] !== size) {
    t17 = size === "xSmall" && rating && Boolean(rating > 0) ? <HotelCardRating id={id} hasIcon={false} isSuggestedCard={false} propertyId={propertyId} rating={rating} reviewCount={reviewCount} size={size} /> : null;
    $[28] = id;
    $[29] = propertyId;
    $[30] = rating;
    $[31] = reviewCount;
    $[32] = size;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== size || $[35] !== stars) {
    t18 = stars === 0 && size === "xSmall" && <div className="!h-[14px]" />;
    $[34] = size;
    $[35] = stars;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== rating || $[38] !== size) {
    t19 = rating === 0 && size === "xSmall" && <div className="!h-[16px]" />;
    $[37] = rating;
    $[38] = size;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== t15 || $[41] !== t16 || $[42] !== t17 || $[43] !== t18 || $[44] !== t19) {
    t20 = <div className={t15}>{t16}{t17}{t18}{t19}</div>;
    $[40] = t15;
    $[41] = t16;
    $[42] = t17;
    $[43] = t18;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  let t21;
  if ($[46] !== t14 || $[47] !== t20 || $[48] !== t4) {
    t21 = <div className={t4}>{t14}{t20}</div>;
    $[46] = t14;
    $[47] = t20;
    $[48] = t4;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== router.pathname || $[51] !== size || $[52] !== stars) {
    t22 = router.pathname.includes("map") && <HotelCardStars size={size} starSize="large" stars={stars} />;
    $[50] = router.pathname;
    $[51] = size;
    $[52] = stars;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  const t23 = `md:gap-3 ${size === "small" ? `${appName === "villa" || isHomePage && !isHotelDomHomePage ? "!justify-start md:!gap-2" : "!justify-between"} pb-1 md:!gap-1` : ""} flex flex-row ${isMobile ? "!justify-between" : "justify-start"}`;
  let t24;
  if ($[54] !== id || $[55] !== isSuggestedCard || $[56] !== propertyId || $[57] !== rating || $[58] !== reviewCount || $[59] !== size) {
    t24 = size !== "xSmall" && !isSuggestedCard && <HotelCardRating hasIcon={false} id={id} propertyId={propertyId} rating={rating} reviewCount={reviewCount} size={size} />;
    $[54] = id;
    $[55] = isSuggestedCard;
    $[56] = propertyId;
    $[57] = rating;
    $[58] = reviewCount;
    $[59] = size;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  let t25;
  if ($[61] !== address || $[62] !== id || $[63] !== isHotelDomHomePage || $[64] !== isSuggestedCard || $[65] !== location?.lat || $[66] !== location?.lng || $[67] !== propertyId || $[68] !== rating || $[69] !== reviewCount || $[70] !== router || $[71] !== size || $[72] !== stars) {
    t25 = !isSuggestedCard && <div className="flex flex-row items-center justify-between">{size === "small" && (appName === "villa" || isHomePage) && !isHotelDomHomePage && address ? <div className={`${location?.lat && location?.lng && !router?.pathname?.includes("map") ? "text-secondary" : "text-on-surface-medium-emphasis"} text-caption flex flex-row items-center gap-1`}><MaterialIcon name="location_on" variant="outlined" /><span className={`max-w-[110px] truncate ${location?.lat && location?.lng && !router?.pathname?.includes("map") ? "cursor-pointer" : ""}`} onClick={location?.lat && location?.lng && !router?.pathname?.includes("map") ? event_0 => {
          event_0.stopPropagation();
          event_0.preventDefault();
          return router?.push(`${isHomePage ? "/villa" : ""}/map`, {
            ...omit(router?.query, ["cityTitle", "locationType", "extra_capacity", "modal"]),
            selectedHotelId: id,
            coordinate: `${location?.lat},${location?.lng},,15`
          });
        } : undefined}>{address}</span></div> : router.pathname.includes("map") ? null : <HotelCardStars size={size} starSize="large" stars={stars} />}{size === "xSmall" && <HotelCardRating id={id} propertyId={propertyId} rating={rating} reviewCount={reviewCount} size={size} />}</div>;
    $[61] = address;
    $[62] = id;
    $[63] = isHotelDomHomePage;
    $[64] = isSuggestedCard;
    $[65] = location?.lat;
    $[66] = location?.lng;
    $[67] = propertyId;
    $[68] = rating;
    $[69] = reviewCount;
    $[70] = router;
    $[71] = size;
    $[72] = stars;
    $[73] = t25;
  } else {
    t25 = $[73];
  }
  let t26;
  if ($[74] !== t23 || $[75] !== t24 || $[76] !== t25) {
    t26 = <div className={t23}>{t24}{t25}</div>;
    $[74] = t23;
    $[75] = t24;
    $[76] = t25;
    $[77] = t26;
  } else {
    t26 = $[77];
  }
  let t27;
  if ($[78] !== roomTitle || $[79] !== router.locale || $[80] !== size) {
    t27 = roomTitle && size === "small" && appName === "villa" && <div className={`${size === "small" ? "w-[200px]" : "w-[120px]"} text-on-surface-medium-emphasis flex items-center justify-start gap-1 md:w-[200px]`}>{size === "small" && <MaterialIcon name="person" />}<span className={`text-caption ${size === "small" ? "" : "truncate"}`} data-testid="hotel_card_room_title">{numberConvert(roomTitle, {
          numberOnly: false,
          locale: router.locale
        })}</span></div>;
    $[78] = roomTitle;
    $[79] = router.locale;
    $[80] = size;
    $[81] = t27;
  } else {
    t27 = $[81];
  }
  let t28;
  if ($[82] !== hasDate || $[83] !== hasPassenger || $[84] !== pricing?.basePriceOff || $[85] !== pricing?.price || $[86] !== router.locale || $[87] !== size) {
    t28 = appName === "villa" && hasDate && hasPassenger && pricing?.price && pricing?.basePriceOff && size === "small" ? <div className="text-on-surface-medium-emphasis flex items-center justify-start gap-1"><MaterialIcon name="payments" variant="outlined" /><div className="text-caption whitespace-nowrap pe-1">شروع قیمت از</div><div className="flex flex-col items-end gap-1"><div className="text-subtitle-2">{numberConvert(numberSeparator(pricing?.basePriceOff), {
            locale: router.locale || "fa"
          })}<span className="text-caption px-1">تومان</span></div></div></div> : null;
    $[82] = hasDate;
    $[83] = hasPassenger;
    $[84] = pricing?.basePriceOff;
    $[85] = pricing?.price;
    $[86] = router.locale;
    $[87] = size;
    $[88] = t28;
  } else {
    t28 = $[88];
  }
  let t29;
  if ($[89] !== transportation) {
    t29 = appName === "tour" && transportation ? <div className="flex flex-row items-center gap-1">{transportation.icons.map(_temp)}<div className="text-on-surface-high-emphasis text-sm">{transportation.text}</div></div> : null;
    $[89] = transportation;
    $[90] = t29;
  } else {
    t29 = $[90];
  }
  let t30;
  if ($[91] !== address || $[92] !== facilities || $[93] !== isFomo || $[94] !== isSuggestedCard || $[95] !== regularBadges || $[96] !== roomCount || $[97] !== roomTitle || $[98] !== size) {
    t30 = size !== "xSmall" && <HotelCardInfoOptions className={size === "small" ? "flex flex-col gap-2" : "flex flex-col gap-2 lg:gap-1"} address={address} facilities={facilities} isFomo={isFomo} isSuggestedCard={isSuggestedCard} regularBadges={regularBadges} roomCount={roomCount} roomTitle={roomTitle} size={size} />;
    $[91] = address;
    $[92] = facilities;
    $[93] = isFomo;
    $[94] = isSuggestedCard;
    $[95] = regularBadges;
    $[96] = roomCount;
    $[97] = roomTitle;
    $[98] = size;
    $[99] = t30;
  } else {
    t30 = $[99];
  }
  let t31;
  if ($[100] !== isAvailable || $[101] !== loading || $[102] !== pricing?.price || $[103] !== pricing?.priceOff || $[104] !== size || $[105] !== snappPayData) {
    t31 = size !== "small" && size !== "xSmall" && <div className="mt-auto hidden md:block">{isAvailable && <HotelSnappPayBadge {...snappPayData} loading={loading} page="cityPage" price={pricing?.priceOff || pricing?.price} />}</div>;
    $[100] = isAvailable;
    $[101] = loading;
    $[102] = pricing?.price;
    $[103] = pricing?.priceOff;
    $[104] = size;
    $[105] = snappPayData;
    $[106] = t31;
  } else {
    t31 = $[106];
  }
  const t32 = `${size === "small" && !isMobile ? "" : "mb-2"} flex flex-row items-center ${appName === "villa" || isHomePage ? "justify-start" : "justify-between"} gap-1`;
  let t33;
  if ($[107] !== address || $[108] !== id || $[109] !== isHotelDomHomePage || $[110] !== isInternational || $[111] !== isSuggestedCard || $[112] !== isVillaAllowed || $[113] !== location?.lat || $[114] !== location?.lng || $[115] !== router || $[116] !== showMap) {
    t33 = !router.pathname.includes("map") && !isSuggestedCard && (showMap || address) && (isVillaAllowed || isHotel || isHotelDomHomePage) ? <div className="flex min-w-0 items-center justify-start gap-1"><MaterialIcon className={`shrink-0 ${showMap ? "text-secondary" : "text-on-surface-high-emphasis"}`} name="location_on" variant="outlined" /><span className={`md:max-w-[255px] ${showMap ? "text-secondary cursor-pointer" : "text-on-surface-high-emphasis"} text-caption truncate`} dir={isInternational && appName !== "tour" ? "ltr" : ""} onClick={event_1 => {
        event_1.stopPropagation();
        event_1.preventDefault();
        if (!showMap) {
          return;
        }
        if (appName === "hotel-domestic" && location?.lat && location?.lng) {
          return router?.[router.pathname.includes("map") ? "replace" : "push"](`${isHomePage ? "/villa" : ""}/map`, {
            ...omit(router?.query, ["hotelTitle", "cityTitle", "locationType", "extra_capacity", "modal"]),
            selectedHotelId: id,
            coordinate: `${location?.lat},${location?.lng},11,33`
          });
        }
        return router.replace(router?.pathname, {
          ...router?.query,
          modal: "map",
          selectedHotelId: id
        }, {
          shallow: true,
          scroll: false
        });
      }}>{address ?? "\u0645\u0634\u0627\u0647\u062F\u0647 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647"}</span></div> : <div />;
    $[107] = address;
    $[108] = id;
    $[109] = isHotelDomHomePage;
    $[110] = isInternational;
    $[111] = isSuggestedCard;
    $[112] = isVillaAllowed;
    $[113] = location?.lat;
    $[114] = location?.lng;
    $[115] = router;
    $[116] = showMap;
    $[117] = t33;
  } else {
    t33 = $[117];
  }
  let t34;
  if ($[118] !== onHotelDetailClick) {
    t34 = appName === "tour" ? <button className="text-secondary text-caption min-w-max cursor-pointer max-md:text-start" type="button" onClick={onHotelDetailClick}>جزییات هتل</button> : null;
    $[118] = onHotelDetailClick;
    $[119] = t34;
  } else {
    t34 = $[119];
  }
  const t35 = `flex flex-wrap justify-start gap-3 ${!isInstant && (!regularBadges?.length || appName !== "villa") ? "hidden" : ""} ${(process.env.NEXT_PUBLIC_APP_NAME === "villa" || isHomePage) && isMobile && "mb-2"}`;
  let t36;
  if ($[120] !== isInstant) {
    t36 = isInstant && <MiniChips StartIcon={<MaterialIcon name="bolt" />} className={`!bg-warning !text-on-surface-high-emphasis ${isInstant ? "" : "!hidden"}`} text={"\u0631\u0632\u0631\u0648 \u0622\u0646\u06CC"} variant="contained" />;
    $[120] = isInstant;
    $[121] = t36;
  } else {
    t36 = $[121];
  }
  let t37;
  if ($[122] !== regularBadges || $[123] !== router.locale) {
    t37 = process.env.NEXT_PUBLIC_APP_NAME === "villa" && Boolean(regularBadges?.length) && regularBadges?.map((badge, index) => <MiniChips key={`${badge.text}-${index}`} text={numberConvert(badge.text, {
      locale: router.locale || "fa"
    })} variant="accent" />);
    $[122] = regularBadges;
    $[123] = router.locale;
    $[124] = t37;
  } else {
    t37 = $[124];
  }
  let t38;
  if ($[125] !== t35 || $[126] !== t36 || $[127] !== t37) {
    t38 = <div className={t35}>{t36}{t37}</div>;
    $[125] = t35;
    $[126] = t36;
    $[127] = t37;
    $[128] = t38;
  } else {
    t38 = $[128];
  }
  let t39;
  if ($[129] !== t32 || $[130] !== t33 || $[131] !== t34 || $[132] !== t38) {
    t39 = <div className={t32}>{t33}{t34}{t38}</div>;
    $[129] = t32;
    $[130] = t33;
    $[131] = t34;
    $[132] = t38;
    $[133] = t39;
  } else {
    t39 = $[133];
  }
  let t40;
  if ($[134] !== t21 || $[135] !== t22 || $[136] !== t26 || $[137] !== t27 || $[138] !== t28 || $[139] !== t29 || $[140] !== t3 || $[141] !== t30 || $[142] !== t31 || $[143] !== t39) {
    t40 = <div className={t3}>{t21}{t22}{t26}{t27}{t28}{t29}{t30}{t31}{t39}</div>;
    $[134] = t21;
    $[135] = t22;
    $[136] = t26;
    $[137] = t27;
    $[138] = t28;
    $[139] = t29;
    $[140] = t3;
    $[141] = t30;
    $[142] = t31;
    $[143] = t39;
    $[144] = t40;
  } else {
    t40 = $[144];
  }
  return t40;
};
function _temp(icon) {
  return <MaterialIcon key={`icon-${icon}`} className={`text-xl ${icon === "flight" ? "rotate-45" : ""}`} name={icon} />;
}